'use client'

import { memo, useEffect } from 'react'

import { initUrlSync } from '@/core/stores/navigationStore'

import { Card } from './Card'

function CardWithParamsComponent() {
  // Initialize URL synchronization on mount
  useEffect(() => {
    initUrlSync()
  }, [])

  return <Card />
}

export const CardWithParams = memo(CardWithParamsComponent)
